import type {ClickPaywallCarouselProperties} from '@gaia/ampli';
import theme from '@gaia/theme';
import {Typography} from '@mui/material';

import UpsellCardButtons from './UpsellCardButtons';

export type UpsellFeatureCardProps = {
    key: ClickPaywallCarouselProperties['cardViewed'];
    headline: string;
    bodyText: string;
    imgSrc: string;
    imgAltText: string;
};

export default function UpsellFeatureCard({
    headline,
    bodyText,
    imgSrc,
    imgAltText,
}: UpsellFeatureCardProps) {
    return (
        <>
            <div
                style={{
                    height: 480,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                <img
                    style={{
                        width: '100%',
                        margin: theme.spacing(2),
                    }}
                    src={imgSrc}
                    alt={imgAltText}
                />
                <div
                    style={{
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(2),
                        paddingTop: theme.spacing(2.5),
                        textAlign: 'left',
                    }}
                >
                    <Typography variant='h4' component='h2'>
                        {headline}
                    </Typography>
                    <Typography
                        variant='body1'
                        style={{
                            lineHeight: 18 / 14,
                            marginTop: theme.spacing(2),
                        }}
                    >
                        {bodyText}
                    </Typography>
                </div>
            </div>
            <UpsellCardButtons />
        </>
    );
}
